import { render } from "./FacilityInformation.vue?vue&type=template&id=2b140b40&scoped=true"
import script from "./FacilityInformation.vue?vue&type=script&lang=js"
export * from "./FacilityInformation.vue?vue&type=script&lang=js"

import "./FacilityInformation.vue?vue&type=style&index=0&id=2b140b40&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b140b40"]])

export default __exports__